<template>
    <div class="login">

    </div>
</template>

<script>
export default {
    name: "Login",
    components: {

    },
    data() {
        return {
            code: '',
        };
    },
    created() {
        this.getCode()
    },
    methods: {
        getCode() { // 非静默授权，第一次有弹框
            let code = this.getUrlParam('code') // 截取路径中的code，如果没有就去微信授权，如果已经获取到了就直接传code给后台获取
            let local = window.location.href
            var appid = 'wxaeaae8c79907b249'
            if (code == null || code === '') {
                window.location.href = `https://open.weixin.qq.com/connect/oauth2/authorize?appid=${appid}&redirect_uri=${encodeURIComponent(local)}&response_type=code&scope=snsapi_userinfo&wechat_redirect`
            } else {
                // this.getOpenId(code) //把code传给后台获取用户信息
                this.code = code;
                this.login()
            }
        },
        getUrlParam: function (name) {
            var reg = new RegExp('(^|&)' + name + '=([^&]*)(&|$)')
            var r = window.location.search.substr(1).match(reg)
            if (r != null) return unescape(r[2])
            return null
        },
        //2.用微信回传的code登录
        login() {
            this.$http.get("/wx/login", { params: { code: this.code } }).then(res => {
                this.loading = false;
                if (res.data.code == 0) {
                    this.userInfo = res.data.data.user;
                    localStorage.setItem("token", res.data.data.token);
                    this.$store.commit("setUser", this.userInfo);
                    if (this.userInfo.phone == null || this.userInfo.phone == '') {
                        this.$router.push({
                            path: "/bindphone",
                        })
                    } else {
                        this.$weui.toast("登录成功")
                        let path = '/#/home'
                        let url = window.location.origin + path;
                        window.location.href = url
                    }
                }
            });
        },
    },
    mounted() {

    }
};
</script>

<style lang='less' scoped>
.login {
    width: 630px;
    .logo {
        width: 630px;
        margin-top: 100px;
        img {
            width: 100px;
        }
        .p1 {
            font-size: 40px;
            color: #333333;
            padding: 30px 0 10px;
        }
        .p2 {
            font-size: 26px;
            color: #999999;
            padding-bottom: 47px;
        }
    }
    .item {
        width: 630px;
        margin: 0 auto;
    }
    .item1 {
        input {
            padding-left: 64px;
            width: 566px;
            height: 100px;
            border-bottom: 1px solid #eeeeee;
            font-size: 28px;
            background: url("../../assets/img/phone.png") no-repeat left center;
            background-size: 40px auto;
        }
    }
    .yzm {
        display: flex;
        align-items: center;
        border-bottom: 1px solid #eeeeee;
        justify-content: space-between;
        height: 100px;
        input {
            font-size: 28px;
            padding-left: 64px;
            background: url("../../assets/img/yzm.png") no-repeat left center;
            background-size: 40px auto;
        }
        button {
            width: 168px;
            height: 50px;
            background: #f5f5f5;
            font-size: 24px;
            color: #999999;
        }
    }
    .submit {
        width: 630px;
        height: 90px;
        margin: 80px auto 0;
        background: #2865ff;
        border-radius: 45px;
        border-radius: 45px;
        font-size: 34px;
        color: #ffffff;
    }
}
input[type="number"]::-webkit-inner-spin-button,
input[type="number"]::-webkit-outer-spin-button {
    -webkit-appearance: none;
    margin: 0;
}

/*** 消除input元素 type="number" 时默认的 加减按钮---moz版*/
input[type="number"] {
    -moz-appearance: textfield;
}
</style>